export default {
  // Common words
  enter: "Vnesi",
  next: "Naprej",
  previous: "Prejšnje",
  finish: "Končaj",
  returnToWebsite: "Nazaj na spletno mesto",
  complete: "Dokončaj",
  submit: "Pošlji",
  cancel: "Prekliči",
  yes: "Da",
  no: "Ne",
  skip: "Preskoči",
  close: "Zapri",
  discard: "Zavrzi",
  save: "Shrani",
  "thank-you": "Hvala",
  select: "Izberi",
  hi: "Živjo",
  hello: "Pozdravljeni",
  link: "Povezava",
  back: "Nazaj",
  view: "Prikaži",
  continue: "Nadaljuj",
  of: "od",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Hvala, ker ste si vzeli čas, vaše povratne informacije oblikujejo našo ponudbo <br /> za prihodnost.",
  "client-survey-how-likely-recommend":
    "Kako verjetno bi nas priporočili drugim?",
  "client-survey-how-likely-note":
    "Na lestvici od 0 do 10, kjer 0 pomeni sploh ni verjetno, 10 pa izjemno verjetno.",
  "client-survey-how-likely-recommend-question":
    "Katera je tista ena stvar, ki bi jo lahko storili, da bi nas z večjo verjetnostjo priporočili?",
  "step-of": "Korak {step} od {total}",
  step: "Korak {step}",
  "client-survey-how-satisfied-with-service":
    "Kako zadovoljni ste s storitvijo",
  "client-survey-how-satisfied-with-service-question":
    "Katera je tista ena stvar, ki bi jo lahko izboljšali?",
  "client-survey-how-satisfied-with-food":
    "Kako zadovoljni ste s hrano, ki jo prejemate od nas?",
  "client-survey-how-satisfied-with-food-question":
    "Katera je tista ena stvar, ki bi jo lahko izboljšali?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Katera je najboljša stvar pri sodelovanju z nami? Izberite vse, kar vam je pomembno.",
  "management-team": "Vodstvena ekipa",
  "the-front-line-operations-team": "Operativna ekipa na prvi liniji",
  "food-offering": "Ponudba hrane",
  innovation: "Inovativnost",
  communication: "Komunikacija",
  "flexibility-and-responsiveness": "Prilagodljivost in odzivnost",
  billing: "Obračun",
  "health-and-hygiene-standards": "Zdravstveni in higienski standardi",
  "if-other-please-specify": "Če drugo, navedite ...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Na podlagi storitve, ki jo ponujamo, kje se lahko najbolj izboljšamo? Izberite vse, kar vam je pomembno.",
  "please-can-we-have-some-more-detail": "Nam lahko poveste kaj več?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Da bomo razumeli vaše prioritete na področju družbene odgovornosti, razvrstite naslednje po pomembnosti:",
  "sustainable-ingredients": "Trajnostne sestavine",
  "food-waste": "Zavržena hrana",
  "local-sourcing": "Lokalna nabava",
  "people-and-communities": "Ljudje in skupnosti",
  "energy-reduction": "Zmanjšanje porabe energije",
  "working-with-local-communities": "Sodelovanje z lokalnimi skupnostmi",
  "environmental-choices": "Okoljske izbire",
  "meat-free": "Brez mesa",
  "less-plastic": "Manj plastike",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Želite, da vas kontaktiramo glede vaših povratnih informacij? Če da, spodaj pustite svoje kontaktne podatke",
  "full-name": "Ime in priimek",
  "email-address": "E-poštni naslov",
  "phone-number": "Telefonska številka",
  feedback: "Povratne informacije",
  "view-our-privacy-policy": "Oglejte si našo Politiko zasebnosti",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Hvala, ker ste si vzeli čas za izpolnitev ankete!",

  // 404 Not Found
  "404-not-found": "404 Ni najdeno",

  // Privacy Policy
  "privacy-policy": "Politika zasebnosti",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Veseli nas, da se počutite pozitivno, radi bi izvedeli zakaj?",
  "employee-web-rating-feedback-step-1-negative":
    "Žal nam je, da se ne počutite najbolje, nam lahko poveste zakaj?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Je še kaj, kar bi danes želeli deliti z nami?",
  "employee-web-rating-feedback-step-2-information":
    "Imate kakšne komentarje ali povratne informacije o svoji današnji izkušnji z nami?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Delite z nami svojo današnjo izkušnjo ...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Želite nekomu izreči pohvalo?",
  "no-employees-found": "Ni najdenih zaposlenih",

  // Employee Web Rating Home
  "choose-location": "Izberite lokacijo",
  "search-location": "Poiščite lokacijo",
  "feedback-anonymous":
    "Želite, da vaše povratne informacije ostanejo anonimne?",
  "feedback-feeling-today": "Kako se danes počutite?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Hvala za vaše povratne informacije!",
  "back-to-home": "Nazaj na začetno stran",
  page: "Stran",

  // Feedback Once Alert
  "feedback-once-alert":
    "Povratne informacije s tega URL-ja so bile že enkrat podane.",

  // Front Customer Audit
  "please-answer-above-question": "Odgovorite na zgornje vprašanje.",
  "add-comments": "Dodajte komentarje",
  "enter-answer": "Vnesite odgovor",
  "add-upload-files": "Dodajte / naložite datoteke",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Ste danes v lekarni kupili zdravilo?",
  "were-you-asked-any-of-the-following": "So vas vprašali kaj od naslednjega:",
  "who-is-the-medicine-for": "Za koga je zdravilo?",
  "what-are-your-symptoms": "Kakšni so vaši simptomi?",
  "how-long-you-had-the-symptoms": "Kako dolgo že imate simptome?",
  "what-action-you-have-already-taken": "Katere ukrepe ste že sprejeli?",
  "are-you-taking-any-other-medication": "Jemljete še katera druga zdravila?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Ste na postrežbo čakali več kot 10 minut?",
  "were-the-products-you-wanted-in-stock": "So bili želeni izdelki na zalogi?",
  "were-the-staff-friendly-and-helpful":
    "Je bilo osebje prijazno in ustrežljivo?",
  "did-you-receive-any-advice-about-your-medicines":
    "Ste prejeli kakšen nasvet o svojih zdravilih?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Kakšna je bila vaša današnja izkušnja z nami?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Hvala za vaš čas in vaše odgovore.",
  "would-also-like-to-rate-us-on-google":
    "Bi nas želeli oceniti tudi na Googlu?",
  "rate-us-now": "Ocenite nas zdaj",

  // Negative Chat Reply
  "select-skill": "Izberite veščino",
  "none-selected": "Nič ni izbrano",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Vas lahko kontaktiramo glede vaše današnje izkušnje?",
  "write-here": "Pišite tukaj ...",
  "please-can-we-get-your-name": "Nam lahko poveste svoje ime?",
  "please-enter-your-email": "Vnesite svojo e-pošto:",
  "enter-your-phone-number": "Vnesite svojo telefonsko številko:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Povejte nam kaj več o svoji izkušnji:",
  "you-have-already-submitted-rating": "Oceno ste že oddali",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Žal nam je, da danes z nami niste imeli najboljše izkušnje, nam lahko izpostavite, kaj je šlo narobe?",

  // Positive Chat Reply
  "select-employee": "Izberite zaposlenega",
  "we-d-love-to-know-who-looked-after-you-today":
    "Radi bi izvedeli, kdo je danes skrbel za vas?",
  "what-stood-out-to-you-today": "Kaj je danes izstopalo za vas?",
  "did-we-provide-exceptional-service-today":
    "Smo vam danes nudili izjemno storitev?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Imate kakšne komentarje ali povratne informacije o svoji današnji izkušnji z nami?",

  // Client Connect Director
  "message-from-leadership": "Sporočilo vodstva",
  "message-from-leadership-text":
    "Nenehno iščem načine, kako izboljšati našo ponudbo za naše stranke. Ali po vašem mnenju obstajajo vidiki, ki bi jih lahko izboljšali?",
  "client-connect-director-another-note":
    "Mimogrede, če obstaja določena tema, ki bi jo želeli, da jo naša ekipa obravnava, jo brez oklevanja delite. Tu nisem le zato, da poslušam, ampak da se vključim in ukrepam na podlagi vaših skrbi ali idej.",
  "your-message-here": "Vaše sporočilo tukaj",
  "visit-information": "Informacije o obisku",
  "visit-time-out": "Čas odhoda",
  "contact-information": "Kontaktni podatki",
  "client-connect-director-contact-information-text":
    "Da bi vam lahko nudili boljšo pomoč, vas vljudno prosimo za vaše podatke, vključno z imenom, e-poštnim naslovom in kontaktno številko. Te informacije nam bodo omogočile, da se hitro odzovemo in vas kontaktiramo.",
  name: "Ime",
  "enter-your-name": "Vnesite svoje ime",
  email: "E-pošta",
  "enter-your-email": "Vnesite svojo e-pošto",
  "contact-number": "Kontaktna številka",
  "please-enter-your-name": "Vnesite svoje ime",
  "please-enter-your-email-or-phone-number":
    "Vnesite svojo e-pošto ali telefonsko številko",
  "invalid-email-address": "Neveljaven e-poštni naslov",
  "invalid-phone-number-format":
    "Neveljavna telefonska številka za izbrano državo.",
  "no-match-found": "Ni zadetkov",
  "phone-number-must-be-digits-for-country":
    "Telefonska številka mora imeti {count} števk za izbrano državo ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Telefonska številka mora imeti {min}–{max} števk za izbrano državo ({current}/{max}).",
  "please-select-time": "Izberite čas",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Pred oddajo ankete morate podati vsaj en odgovor.",

  // Mobile Survey Questions CheckBoxType
  comment: "Komentar",
  "comment-is-required": "Komentar je obvezen!",
  "minimum-selection-is": "Najmanjši izbor je {min_options}",
  "maximum-selection-is": "Največji izbor je {max_options}",
  "this-question-is-required": "To vprašanje je obvezno!",
  "please-fill-all-required-grid-rows": "Izpolnite vse obvezne vrstice tabele!",
  "please-fill-mandatory-fields-to-continue":
    "Za nadaljevanje izpolnite obvezna polja",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Izberite veljavne slikovne datoteke.",

  // Mobile Survey Questions EmployeeType
  loading: "Nalaganje",
  "getting-employee": "Pridobivanje zaposlenega ...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Izberite veljavne slikovne ali video datoteke.",
  "please-select-a-valid-file":
    "Izberite veljavno datoteko (slika, video, PDF ali Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Vnesite število brez decimalnih mest.",
  "please-enter-a-number-less-than-or-equal-to":
    "Vnesite število, manjše ali enako {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Dokončajte svoj podpis.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address": "Vnesite veljaven e-poštni naslov.",
  "phone-number-should-be-10-digit": "Telefonska številka mora imeti 10 števk.",
  "please-enter-at-least-characters":
    "Vnesite vsaj {minimum_character} znakov.",
  "select-date": "Izberite datum",
  "select-time": "Izberite čas",
  "client-connect-date-picker-aria": "Datum: {value}. Odpri izbirnik datuma",
  "client-connect-time-picker-aria": "Čas: {value}. Odpri izbirnik časa",
  "select-country": "Izberite državo",

  // Report Page
  "click-the-link-to-see-how": "Kliknite povezavo, da vidite, kako.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Z dodajanjem svojih ekip na platformo za poročanje ServeFirst se lahko tudi one prijavijo in si ogledajo svojo uspešnost; prav tako lahko upravljate svojo ekipo in dostopate do dodatnih poročil, da razumete, kako se odrezujete na splošno -",
  "did-you-know": "Ste vedeli ..",
  count: "število",
  average: "povprečje",
  focus: "fokus",
  performance: "Uspešnost",
  "you-can-create-bespoke-action-plans":
    "Ustvarite lahko prilagojene akcijske načrte, ki se filtrirajo neposredno sem, če so ustvarjeni v vašem računu ServeFirst; tukaj lahko takoj ustvarjate ukrepe, časovnice in lastnike ter spremljate uspešnost. -",
  "no-of-times-raised": "Št. izpostavitev",
  action: "Ukrep",
  "attribute-name": "Ime atributa",
  "action-plan": "Akcijski načrt",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Z dodajanjem svojih ekip na platformo za poročanje ServeFirst se lahko tudi one prijavijo in si ogledajo svojo uspešnost; prav tako lahko upravljate svojo ekipo in dostopate do dodatnih poročil, da razumete, kako se odrezujete na splošno -",
  result: "Rezultat",
  category: "Kategorija",
  "your-location-vs-all-location":
    "Vaša lokacija v primerjavi z vsemi lokacijami",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Razčlenitev odgovorov",
  "trended-net-promoter-score": "Net Promoter Score s trendom",
  "trended-results": "Rezultati s trendom",
  "net-promoter-score-info":
    "Net Promoter Score temelji na % promotorjev (ocena 5/5) - % kritikov (ocena 1, 2 ali 3); več o Net Promoter Score izveste s klikom na naslednje",
  "customer-feedback": "Povratne informacije strank",
  logan: "Logan",
  "top-performer": "Najuspešnejši",
  "rank-in-the-country": "Uvrstitev v državi",
  "ytd-score": "Rezultat od začetka leta",
  "score-during-period": "Rezultat v obdobju",
  "0-from-last-month": "0 od prejšnjega meseca",
  "total-responses-for-july-2021": "Skupno odgovorov za julij 2021",
  promoter: "Promotor",
  "from-04-sep-2021-to-06-sep-2021": "Od 04. sep. 2021 do 06. sep. 2021",
  "the-focus-currently-is-on": "Trenutni fokus je na",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 stranka je to navedla kot priložnost.",
  "focus-for-the-month": "Fokus za mesec",
  "download-pdf": "Prenesi pdf",

  // Report Page New Report
  "total-responses": "Skupno odgovorov",
  duration: "Trajanje",
  "customers-have-stated-this-as-an-opportunity":
    "strank je to navedlo kot priložnost",
  "error-fetching-params": "Napaka pri pridobivanju parametrov!",
  "previous-days-was": "Prejšnjih {days} dni je bilo {score}",

  // Report Page Common LgCard
  "raised-on": "# Izpostavljeno",
  results: "Rezultati",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Analiziranje podatkov, počakajte ...",

  // Report Page Components CustomerFeedBack
  "view-report": "Prikaži poročilo",
  "received-on": "Prejeto",

  // Report Page Components ResponseBreakdown
  detractors: "Kritiki",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Rezultati trenda",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Pridobivanje datoteke PDF ni uspelo",
  "error-generating-pdf-thumbnail": "Napaka pri ustvarjanju sličice PDF",
  "error-in-thumbnail-generation-function":
    "Napaka v funkciji za ustvarjanje sličic",
  "failed-to-generate-pdf-thumbnail": "Ustvarjanje sličice PDF ni uspelo",

  // Survey Pages Audition
  "select-audit": "Izberite presojo",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Izberite vsaj {minOptions} možnosti",
  "select-max-options": "Dovoljenih je največ {maxOptions} možnosti!",
  "error-saving-your-response": "Napaka pri shranjevanju vašega odgovora!",
  "failed-to-load-the-file": "Nalaganje datoteke ni uspelo!",
  "open-link": "Odpri povezavo",
  download: "Prenesi",
  details: "Podrobnosti",
  title: "Naslov",
  description: "Opis",
  "general-info": "Splošne informacije",
  type: "Vrsta",
  size: "Velikost",
  "uploaded-by": "Naložil",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Hvala za vaš čas!",

  // Survey Pages ClientConnect Content
  "review-content": "Preglej vsebino",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Posredujte nam svoje povratne informacije",
  "enter-your-response": "Vnesite svoj odgovor",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Pozdravljeni, {name}",
  "client-connect-preview-sent-from": "Poslano od {sender} - {date}",
  "client-connect-preview-step-of": "Korak {current} od {total}",
  "client-connect-preview-getting-started": "Začetek",
  "client-connect-preview-getting-started-desc":
    "Oglejte si uvodne vire, pripravljene za vas.",
  "client-connect-preview-share-feedback": "Delite povratne informacije",
  "client-connect-preview-share-feedback-desc":
    "Vaše mnenje nam pomaga ustvariti boljšo izkušnjo za vas.",
  "client-connect-preview-talk-leadership": "Pogovor z vodstvom",
  "client-connect-preview-talk-leadership-desc":
    "Preberite sporočilo vodstva in shranite svoj odgovor.",
  "client-connect-preview-reviewed-these": "Pregledal(a) sem to",
  "client-connect-preview-send-feedback": "Pošlji povratne informacije",
  "client-connect-preview-finish-submit": "Dokončaj in pošlji",
  "client-connect-preview-save-finish": "Dokončaj in pošlji",
  "client-connect-preview-your-reply": "Vaš odgovor",
  "client-connect-preview-saved": "Shranjeno",
  "client-connect-preview-edit": "Uredi",
  "client-connect-preview-pop-out": "Odpri v oknu",
  "client-connect-preview-open": "Odpri",
  "client-connect-preview-view": "Poglej",
  "client-connect-preview-welcome": "Dobrodošli",
  "client-connect-preview-feedback": "Povratne informacije",
  "client-connect-preview-save-message": "Pošlji sporočilo",
  "client-connect-preview-message-footer":
    "Vaše sporočilo gre neposredno vodstveni ekipi.",
  "client-connect-preview-leadership-placeholder": "Vnesite svoje sporočilo...",
  "client-connect-preview-thank-you": "Hvala",
  "client-connect-preview-thank-you-body":
    "Dokončali ste Client Connect. Vaši odgovori na anketo in sporočilo so bili poslani ekipi — kmalu vas bodo kontaktirali.",
  "client-connect-thank-you-message":
    "Hvala za vaš čas. Vaše povratne informacije resnično pomenijo.",
  "client-connect-preview-review-answers": "Preglej moje odgovore",
  "client-connect-preview-back-dashboard": "Nazaj na nadzorno ploščo",
  "client-connect-preview-already-submitted":
    "Vaše povratne informacije so bile prejete. Hvala! Kar pogledajte materiale zgoraj.",
  "enter-email-address": "Vnesite e-poštni naslov",
  "enter-phone-no": "Vnesite telefonsko številko",
  "product-type": "Vrsta izdelka",
  "enter-number": "Vnesite številko",
  aspect: "Vidik",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Nenehno iščem načine, kako izboljšati našo ponudbo za naše stranke. Ali po vašem mnenju obstajajo vidiki, ki bi jih lahko izboljšali?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Mimogrede, če obstaja določena tema, ki bi jo želeli, da jo naša ekipa obravnava, jo brez oklevanja delite. Tu nisem le zato, da poslušam, ampak da se vključim in ukrepam na podlagi vaših skrbi ali idej.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Da bi vam lahko nudili boljšo pomoč, vas vljudno prosimo za vaše podatke, vključno z imenom, e-poštnim naslovom in kontaktno številko. Te informacije nam bodo omogočile, da se hitro odzovemo in vas kontaktiramo.",

  // Survey Pages Location
  "select-the-location-you-visited": "Izberite lokacijo, ki ste jo obiskali",
  locations: "Lokacije",
  "is-this-your-current-location": "Je to vaša trenutna lokacija?",
  "nearest-location": "Najbližja lokacija",
  "loading-data": "Nalaganje podatkov ...",
  "please-wait": "Počakajte!",

  // Survey Pages Location Area
  "location-area": "Območje lokacije",
  "select-location-area": "Izberite območje lokacije",

  // Survey Pages Login
  "please-enter-your-password": "Vnesite svoje geslo",
  "value-must-be-longer-than-3-characters":
    "Vrednost mora biti daljša od 3 znakov",
  "please-enter-your-email-address": "Vnesite svoj e-poštni naslov",
  password: "Geslo",
  "internal-server-error": "Notranja napaka strežnika!",
  "sign-in": "Prijava",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey": "To anketo ste že izpolnili!",
  "csat-link-invalid": "Ta povezava do ankete ni več veljavna.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Vaše povratne informacije so bile poslane. Vaša številka zahtevka je #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Član ekipe vas bo kmalu kontaktiral.",
  "would-you-also-like-to-rate-us-on-google":
    "Bi nas želeli oceniti tudi na Googlu?",
  "to-review-our-terms-and-conditions-please-click":
    "Za pregled naših Pogojev poslovanja kliknite",
  here: "Tukaj",
  "ticket-number-copied-to-clipboard":
    "Številka zahtevka je kopirana v odložišče",

  // Survey Pages Welcome
  "visit-date": "Datum obiska",
  "visit-time-in": "Čas prihoda",
  "please-select-date": "Izberite datum",
  "guest-info": "Podatki o gostu",
  "please-select-user": "Izberite uporabnika",
  "get-started": "Začni",

  // Survey Pages InventoryType
  "enter-value": "Vnesite vrednost",
  "getting-product-list": "Pridobivanje seznama izdelkov ...",

  // Survey Pages NotesAndImage
  "upload-file": "Naloži datoteko",

  // Survey Pages NumberType
  "enter-digit": "Vnesite števko",

  // Survey Pages TextArea
  "enter-your-comment": "Vnesite svoj komentar",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Velikost datoteke mora biti manjša od 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Povlecite datoteke sem, velikost datoteke manjša od 10 MB ali",
  "upload-or-drag-and-drop-your-files-here":
    "Naložite ali povlecite in spustite datoteke sem",
  "browse-files": "Prebrskaj datoteke",

  // Survey Pages Questions
  "next-question": "Naslednje vprašanje",
  "save-and-exit": "Shrani in zapri",
  "failed-to-save-and-exit":
    "Vašega napredka ni mogoče shraniti. Poskusite znova.",
  "progress-saved-you-may-close-this-tab":
    "Vaš napredek je shranjen. Zdaj lahko zaprete ta zavihek brskalnika.",
  "please-enter-at-least": "Vnesite vsaj {min} znakov.",
  "contact-no": "Kontaktna številka",
  "please-select-location": "Izberite lokacijo!",
  "please-select-survey": "Izberite anketo!",
  "please-enter-your-email-address-or-phone-number":
    "Vnesite svoj e-poštni naslov ali telefonsko številko.",

  // Utils CompressFiles
  "compression-error": "Napaka pri stiskanju:",

  // Web Rating FrontLogin
  "enter-location-id": "Vnesite ID lokacije",
  "invalid-location-id": "Neveljaven ID lokacije",
  "location-id-required": "ID lokacije je obvezen",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Povejte nam, kakšna je bila vaša današnja izkušnja.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Žal nam je, da danes z nami niste imeli najboljše izkušnje, nam lahko izpostavite, kaj je šlo narobe?",
  "enter-valid-email-address": "Vnesite veljaven e-poštni naslov.",
  "can-we-get-in-touch-with-you": "Vas lahko kontaktiramo?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Vnesite svojo telefonsko številko",
  "write-your-feedback": "Napišite svoje povratne informacije",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Po čem je {employeeName} izstopal za vas?",
  team: "Ekipa",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Vrnite se na prejšnji korak in izberite zaposlenega; brez izbire zaposlenega obrazca s povratnimi informacijami ni mogoče oddati",
  "share-us-your-experience-with-us-today":
    "Delite z nami svojo današnjo izkušnjo ...",
  "did-employee-name-provide-exceptional-service":
    "Je {employeeName} nudil izjemno storitev?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Je {employeeName} izstopal pri zagotavljanju izjemne storitve?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Vnesite uporabniško ime",
  "please-enter-password": "Vnesite geslo",

  // Web Rating New RatingLocations
  search: "Iskanje",
  "select-loction-to-ratings": "Izberite lokacijo za ocenjevanje",
  location: "Lokacija",
  "is-this-your-location": "Je to vaša lokacija?",
  "fetch-details-failed": "Pridobivanje podrobnosti ni uspelo",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Kliknite, kolikor želite",
  "what-made-employee-name-stand-out-to-you":
    "Po čem je {employeeName} izstopal za vas?",
  "what-made-the-team-stand-out-to-you": "Po čem je ekipa izstopala za vas?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Smo izstopali pri zagotavljanju izjemne storitve?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Pustite e-pošto ali telefonsko številko, če želite, da vas kontaktiramo, sicer pustite prazno in pritisnite Naprej",
  "anything-else-you-d-like-to-share": "Želite deliti še kaj?",
  "enter-valid-email": "Vnesite veljavno e-pošto",
  message: "Sporočilo",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Z izpolnitvijo obrazca se strinjate z našimi Pogoji in Politiko zasebnosti.",

  // Web Rating New FrontWebLogin
  login: "Prijava",
  username: "Uporabniško ime",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Pritisnite obrazni izraz, ki najbolje predstavlja, kako se počutite glede svoje izkušnje.",
  "getting-employee-list": "Pridobivanje seznama zaposlenih",
  "getting-skill-data": "Pridobivanje podatkov o veščinah",
  "getting-screen-saver": "Pridobivanje ohranjevalnika zaslona",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Hvala, ker ste nas kontaktirali.",
  "we-ll-be-in-touch-very-soon": "Kmalu se vam bomo oglasili.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "S tem gumbom nas lahko ocenite na Googlu",
  "rate-us-on-google": "Ocenite nas na Googlu",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Kontaktirajte nas",
  "or-you-may-reach-us-on": "... ali nas lahko kontaktirate na.",
  "do-you-want-to-learn-more-about-serve-first":
    "Želite izvedeti več o Serve First?",

  // Web Rating New CommonComponents BottomBar
  saving: "Shranjevanje",
  "please-enter-only-digits-for": "Vnesite samo števke za",
  "please-enter": "Vnesite",
  "enter-value-here": "Vnesite vrednost tukaj",

  // Survey Pages Questions Dropdown
  "please-select": "Izberite",
  "survey-retry-message": "To anketo boste lahko izpolnili čez {value} {unit}.",
  minute: "minuta",
  minutes: "minut",
  hour: "ura",
  hours: "ur",
  day: "dan",
  days: "dni",
  week: "teden",
  weeks: "tednov",
  month: "mesec",
  months: "mesecev",
  clear: "Počisti",

  "powered-by": "Poganja",
  "image-is-required": "Slika je obvezna",
  "please-fill-all-required-contact-information":
    "Izpolnite vse obvezne kontaktne podatke",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Morebitne dodatne povratne informacije pustite v spodnjem polju.",
  "all-feedback-is-confidential": "Vse povratne informacije so zaupne",
  "your-feedback-has-been-received-thank-you":
    "Vaše povratne informacije smo prejeli, hvala",
  "close-page": "Zapri stran",
  send: "Pošlji",
  sending: "Pošiljanje",
  "enter-your-feedback-here": "Tukaj vnesite svoje povratne informacije",
  "for-anything-else-please": "Za vse ostalo ",
  "please-correct-the-custom-field-values": "Popravite vrednosti polj po meri",
  "please-complete-all-required-contact-information":
    "Izpolnite vse obvezne kontaktne podatke",
  "survey-cannot-be-submitted": "Ankete ni mogoče oddati",
  "please-enter-your-phone": "Vnesite svoj telefon",
  "network-error-please-try-again":
    "Napaka omrežja. Preverite svojo povezavo in poskusite znova.",
  "no-results-found": "Ni najdenih rezultatov",
  "drop-files-here": "Spustite datoteke sem ...",
  "drag-drop-files":
    "Povlecite in spustite datoteke sem ali kliknite za izbiro datotek",
  "max-5-files-5mb": "Največ 5 datotek, po 5 MB, samo slike",
  remove: "Odstrani",

  // Learning & Development

  "ld-module-title": "Učenje in razvoj",
  "ld-no-sign-in-required": "Prijava ni potrebna",
  "ld-progress-warning":
    "Ne zapirajte tega okna — vaš napredek se ne shrani in morali bi začeti znova.",
  "ld-loading-module": "Nalaganje učnega modula…",
  "ld-unable-load-module": "Učnega modula ni mogoče naložiti.",
  "ld-package-not-configured": "Učni paket ni konfiguriran.",
  "ld-start-guidance": "Začni usposabljanje",
  "ld-due-date": "Rok {date}",
  "ld-whats-involved": "Kaj je vključeno",
  "ld-your-progress": "VAŠ NAPREDEK",
  "ld-step-of": "Korak {current} od {total}",
  "ld-watched-in-full": "Ogledano v celoti",
  "ld-video-no-skip": "Lahko previjate nazaj, ne pa naprej",
  "ld-video-muted-counts": "Utišano — predvajanje se še vedno šteje",
  "ld-maximize-document": "Povečaj dokument",
  "ld-minimize-document": "Pomanjšaj dokument",
  "ld-read-percent": "{percent} % prebrano",
  "ld-end-of-document": "Konec dokumenta",
  "ld-scroll-to-continue": "Pomaknite za nadaljevanje",
  "ld-read-to-end": "Prebrano do konca",
  "ld-read-to-end-to-continue": "Preberite do konca za nadaljevanje",
  "ld-loading-document": "Nalaganje dokumenta…",
  "ld-pdf-preview-unavailable":
    "Tega PDF-ja ni mogoče predogledati v brskalniku.",
  "ld-pdf-page-alt": "{title} — stran {page}",
  "ld-knowledge-check": "PREVERJANJE ZNANJA",
  "ld-knowledge-check-title": "{title} — preverjanje znanja",
  "ld-quiz-instruction":
    "Odgovorite na {count, plural, one {# vprašanje} two {# vprašanji} few {# vprašanja} other {# vprašanj}}. Meja za uspeh {passMark} %.",
  "ld-quiz-instruction-pass-only": "Meja za uspeh {passMark} %.",
  "ld-question-of": "VPRAŠANJE {current} OD {total}",
  "ld-guidance-of": "USPOSABLJANJE {current} OD {total}",
  "ld-loading-questionnaire": "Nalaganje vprašalnika…",
  "ld-preparing-questions": "Priprava vaših vprašanj",
  "ld-submit-answers": "Pošlji odgovore",
  "ld-submitting": "Pošiljanje…",
  "ld-ready-to-submit": "Pripravljeno za pošiljanje odgovorov",
  "ld-answer-selected": "Odgovor izbran",
  "ld-select-answer": "Izberite en odgovor za nadaljevanje",
  "ld-pass-mark-note":
    "Za uspeh potrebujete {passMark} % ali več. Odgovorov po pošiljanju ni mogoče spremeniti.",
  "ld-questionnaire-not-configured": "Vprašalnik ni konfiguriran.",
  "ld-unable-load-questionnaire": "Vprašalnika ni mogoče naložiti.",
  "ld-no-visible-questions":
    "Trenutno ni na voljo nobenih vprašanj za to preverjanje znanja.",
  "ld-unable-submit-answers": "Odgovorov ni mogoče poslati. Poskusite znova.",
  "ld-not-passed": "Ni uspelo",
  "ld-completed": "Dokončano",
  "ld-fail-title": "Skoraj ste uspeli — poskusite znova",
  "ld-fail-description":
    "Dosegli ste {score} — meja za uspeh je {passMark} %. Preostalo vam je {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# poskus} two {# poskusa} few {# poskusi} other {# poskusov}}",
  "ld-attempt-of": "Poskus {current} od {total}",
  "ld-fail-alert":
    "Vzemite si trenutek za ponovni pregled vodnika, nato ponovno opravite preverjanje. Po zadnjem poskusu bo preverjanje zaklenjeno.",
  "ld-try-again": "Poskusi znova",
  "ld-review-guidance": "Preglej vodnik",
  "ld-locked-title": "Ta usposabljanje je zdaj zaklenjeno",
  "ld-locked-description":
    "Dosegli ste {score} — meja za uspeh tega paketa je {passMark} %. Zaradi skladnosti ga tukaj ne morete ponoviti.",
  "ld-speak-to-manager": "Pogovorite se s svojim vodjo",
  "ld-locked-manager-copy":
    "Vaš vodja izmene lahko ponovno dodeli {courseTitle}, da lahko ponovno preidete vodnik in ponovno opravite preverjanje.",
  "ld-close-window": "Zdaj lahko zaprete to okno.",
  "ld-close-window-safe": "Zdaj lahko varno zaprete to okno.",
  "ld-success-title": "Čestitamo!",
  "ld-success-description":
    "Uspešno ste dokončali {courseTitle}. To je zabeleženo v vašem profilu usposabljanja — ničesar več ni treba storiti.",
  "ld-email-yourself": "Pošljite si kopijo",
  "ld-email-copy-description":
    "Pošljite potrdilo o dokončanju v svoj nabiralnik za evidenco.",
  "ld-email-placeholder": "vi@podjetje.si",
  "ld-sent": "Poslano",
  "ld-sending-email": "Pošiljanje…",
  "ld-unable-send-email": "E-pošte ni mogoče poslati. Poskusite znova.",
  "ld-email-sent-success": "Potrditveno e-sporočilo je bilo uspešno poslano!",
  "ld-video-briefing": "Video brifing",
  "ld-document": "Dokument",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · brez preskakovanja",
  "ld-document-meta": "Dokument · PDF",
  "ld-document-meta-scroll": "Dokument · PDF · pomaknite do konca",
  "ld-video-instruction-full":
    "Oglejte si v celoti — ne morete preskakovati naprej",
  "ld-video-instruction": "Oglejte si brifing, nato nadaljujte",
  "ld-document-instruction-scroll": "Pomaknite do konca za nadaljevanje",
  "ld-document-instruction": "Preglejte dokument, nato nadaljujte",
  "ld-questionnaire": "Vprašalnik",
  "ld-confirmation": "Potrditev",
  "ld-question-count":
    "{count, plural, one {# vprašanje} two {# vprašanji} few {# vprašanja} other {# vprašanj}}",
  "ld-knowledge-check-subtitle": "Preverjanje znanja",
  "ld-score": "Rezultat",
  "ld-whats-involved-pass-mark":
    "Meja za uspeh {passMark} % · odkleni se po vodniku",
  "ld-document-type-pdf": "{documentType} · PDF",
};
